<app-page-header header="conclusion_agent.title"></app-page-header>

<app-loader *ngIf="(conclusionStatus$ | async) === apiState.success" view="fixed" />

<div class="nx-margin-bottom-2m">
  <qbe-panel-component>
    <div nxRow class="page-container">
      <div nxCol="12,12,6,5">
        <h2 nxHeadline="section" class="page-headline">
          {{ 'conclusion_agent.documents.headline' | translate }}
        </h2>
      </div>
      <div nxCol="12,12,6,7">
        <ng-container [ngSwitch]="savedCalculationState$ | async">
          <app-loader *ngSwitchCase="apiState.pending"></app-loader>
          <app-error *ngSwitchCase="apiState.error" [appError]="savedCalculationError$ | async"></app-error>
          <ng-container *ngSwitchDefault>
            <a [href]="downloadAllDocuments$ | async" target="_blank" nxButton="secondary" class="nx-margin-bottom-2m">
              <nx-icon name="download" class="nx-margin-right-2xs"></nx-icon>
              {{ 'conclusion_agent.documents.content.button_download' | translate }}
            </a>
            <button
              nxButton="secondary"
              class="nx-margin-bottom-2m"
              (click)="sendEmail()"
              [disabled]="(sendStaticAttachmentsState$ | async) === apiState.pending || !agreement"
            >
              <nx-spinner
                *ngIf="(sendStaticAttachmentsState$ | async) === apiState.pending"
                size="medium"
                class="nx-margin-right-2xs"
              ></nx-spinner>
              <nx-icon
                *ngIf="(sendStaticAttachmentsState$ | async) !== apiState.pending"
                name="mail-o"
                class="nx-margin-right-2xs"
              ></nx-icon>
              {{ 'conclusion_agent.documents.content.button_email' | translate }}
            </button>
            <nx-checkbox class="nx-margin-bottom-m" [(ngModel)]="agreement">
              <span [ngClass]="{ 'hide-text': !agreementFull }">
                {{ 'conclusion_agent.documents.content.agreement' | translate }}
              </span>
            </nx-checkbox>
            <button *ngIf="!agreementFull" nxPlainButton type="button" class="nx-margin-bottom-2m" (click)="toggleAgreement()">
              <nx-icon name="chevron-down" class="nx-margin-right-2xs"></nx-icon>
              {{ 'conclusion_agent.documents.content.agreement_more' | translate }}
            </button>
          </ng-container>
        </ng-container>
        <ng-container [ngSwitch]="sendStaticAttachmentsStatus$ | async">
          <nx-message *ngSwitchCase="apiState.success" context="info" (close)="closeSendStaticAttachmentsNotification()" closable>
            {{ 'conclusion_agent.documents.email_status.success' | translate }}
          </nx-message>
          <nx-message *ngSwitchCase="apiState.error" context="error" (close)="closeSendStaticAttachmentsNotification()" closable>
            {{ 'conclusion_agent.documents.email_status.error' | translate }}
          </nx-message>
        </ng-container>
      </div>
    </div>
  </qbe-panel-component>
</div>

<qbe-panel-component>
  <div nxRow class="page-container">
    <div nxCol="12,12,6,5">
      <h2 nxHeadline="section" class="page-headline">
        {{ 'conclusion_agent.payments.headline' | translate }}
      </h2>
    </div>
    <div nxCol="12,12,6,7">
      <app-radio-buttons [options]="horizontalButtons" [selected]="formOfPayment$ | async" (change)="handlePaymentChange($event)" />
    </div>
  </div>
</qbe-panel-component>
